import { shallowEqual, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

const AuthProvider = (props) => {
  const { children, initURL } = props;
  const { client } = useSelector(({ config }) => config, shallowEqual);
  const { isSystemAdmin, isJnJUser, canAccessMultipleApps } = useSelector(({ auth }) => auth, shallowEqual);
  if (location.pathname === '/') {
    if (
      (client?.maintenanceMode === 'YES' && isSystemAdmin) ||
      !client?.maintenanceMode ||
      client?.maintenanceMode !== 'YES'
    ) {
      if ((initURL === '' || initURL === '/' || initURL === '/dashboard') && !canAccessMultipleApps)  {
        return <Redirect to="/elis/dashboard" />;
      } else if(canAccessMultipleApps && (initURL === '' || initURL === '/' || initURL === '/dashboard')){
        return <Redirect to="/dashboard" />;
      }
      //return props.history.push(initURL)
      return <Redirect to={initURL} />;
    } else {
      //return props.history.push("/maintenance");
      return <Redirect to="/maintenance" />;
    }
  } else if (
    location.pathname !== '/maintenance' &&
    client?.maintenanceMode === 'YES' &&
    !isSystemAdmin
  ) {
    //return props.history.push("/maintenance");
    return <Redirect to="/maintenance" />;
  }

  return children;
};

export default AuthProvider;
